// Shared page exclusion rules for chat widgets (Cobbai and Yuma).
// Documented: https://www.notion.so/Cobbai-Yuma-chat-widget-page-exclusion-rules-35ecf8b9342b40b9a0d84985b86ff3c0
export const PAGES_TO_EXCLUDE_FOR_CHATBOT = [
  '/products/[handle]',
  '/pages/my-lists',
  '/account/register',
  '/account/register-facebook-email',
  '/account/register-newsletter-consent',
  '/account/register/flow',
  '/account/subscription-summary',
  '/pages/paiement',
  '/checkout/register',
  '/pages/subscription-payment',
  '/payment/3ds',
  '/shared-list',
  '/slice-simulator',
  '/first-order-form',
  '/pages/suggestions',
];

// For now need to Exclude wishlist but not frequently bought products page
export const FORCE_PAGES_TO_KEEP_FOR_CHATBOT = [
  '/pages/my-lists?tab=my-purchases',
];

export const PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY = [
  '/cart',
  '/pages/my-lists/[id]',
  '/apps/private-label/result/[slug]',
  '/checkout/delivery',
  '/checkout/payment',
];
